import { getSharedDomain, useCookie } from './useCookie';
import { CookieStorageOptions } from '../services/utils/CookieStorage';
import { Ref } from 'vue';
import { Theme } from '@/types/Theme';

export const THEME_COOKIE = 'lendi-theme' as const;
const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

/**
 * A composable function to manage the theme cookie
 * Uses shared domain (.lendi.pl) so theme preference is shared across all subdomains
 * @returns {Ref<Theme | undefined>} The theme cookie reference
 */
export const useThemeCookie = (): Ref<Theme | undefined> => {
    const sharedDomain = getSharedDomain();
    
    const cookieOptions: Partial<CookieStorageOptions> = {
        domain: sharedDomain,
        path: '/',
        sameSite: 'lax'
    };
    
    return useCookie<Theme | undefined>(THEME_COOKIE, ONE_YEAR_IN_SECONDS, cookieOptions);
};

export default useThemeCookie;
